(() => {
  if (window.WohnjoyCartRemoval) return;
  const prompts = new WeakMap();

  const close = (prompt, restoreFocus = false) => {
    const entry = prompts.get(prompt);
    if (!entry) return;
    prompts.delete(prompt);
    prompt.hidden = true;
    if (entry.info) entry.info.hidden = entry.infoHidden;
    entry.trigger.setAttribute('aria-expanded', 'false');
    if (restoreFocus && entry.control.isConnected) entry.trigger.focus();
    return entry;
  };

  window.WohnjoyCartRemoval = {
    request(control, remove) {
      if (control.dataset.wjRemoveConfirm !== 'true') return false;
      const row = control.closest('.cart-item');
      const prompt = row?.querySelector('[data-wj-removal-prompt]');
      if (!prompt || typeof remove !== 'function') return false;
      if (!prompts.has(prompt)) {
        const info = row.querySelector('[data-wj-cart-item-info]');
        const trigger = control.querySelector('a,button') || control;
        prompts.set(prompt, { control, trigger, info, infoHidden: info?.hidden, remove });
        trigger.setAttribute('aria-expanded', 'true');
        trigger.setAttribute('aria-controls', prompt.id);
        if (info) info.hidden = true;
        prompt.querySelector('[data-wj-removal-error]').hidden = true;
        prompt.hidden = false;
      }
      prompt.querySelector('[data-wj-removal-choice="save"]').focus();
      return true;
    }
  };

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-wj-removal-choice]');
    if (!button) return;
    const prompt = button.closest('[data-wj-removal-prompt]');
    const entry = prompts.get(prompt);
    if (!entry) return;
    event.preventDefault();
    if (button.dataset.wjRemovalChoice === 'cancel') {
      close(prompt, true);
      return;
    }
    // A cart refresh can replace a line while its old controls are still referenced.
    if (!entry.control.isConnected) { close(prompt); return; }
    if (button.dataset.wjRemovalChoice === 'save') {
      const state = window.WohnjoyWishlist;
      const productId = prompt.dataset.productId;
      const variantId = prompt.dataset.variantId;
      const ids = state?.readIds();
      if (!state || !state.remember(productId, variantId) ||
          !state.setIds(ids.includes(productId) ? ids : [...ids, productId], 'cart')) {
        prompt.querySelector('[data-wj-removal-error]').hidden = false;
        return;
      }
    }
    if (!['save', 'remove'].includes(button.dataset.wjRemovalChoice)) return;
    // Close first so a double click cannot trigger a second removal.
    close(prompt);
    entry.remove();
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const prompt = event.target.closest('[data-wj-removal-prompt]');
    if (!prompt || !prompts.has(prompt)) return;
    event.preventDefault();
    event.stopPropagation();
    close(prompt, true);
  }, true);
})();
